import React, {useState} from "react";
import "./buyablesocialmediacard.scss"
import Button from "../../../core/button/button";
import Counter from "../../counter/counter";

export interface IBuyAbleSocialMediaCard {
    image: string
    name: string
    id: string
    verified?: boolean
    follower: string
    options: string[]
    price: string
    cardID: number
    activateSocialMedia: string
    setActivateSocialMedia: React.Dispatch<React.SetStateAction<string>>
}

const BuyAbleSocialMediaCard = ({
                                    image,
                                    name,
                                    id,
                                    verified,
                                    follower,
                                    options,
                                    price,
                                    cardID,
                                    activateSocialMedia,
                                    setActivateSocialMedia
                                }: IBuyAbleSocialMediaCard) => {
    const [count, setCount] = useState(1);
    return (
        <div
            className={activateSocialMedia === `card${cardID}` ? "BuyAble-Social-Media-Card active" : "BuyAble-Social-Media-Card"}>
            <div className="Social-Media-Card-Header text-center">
                <img src={image} alt="" className="img-fluid mx-auto"/>
                <h6 className="Social-Media-Card-Header-Name">{name}</h6>
                <h6 className="Social-Media-Card-Header-ID">{id}</h6>
                <h6 className="Social-Media-Card-Header-Follower">{follower}</h6>
                {verified ? <img src={require("../../../assets/images/icons/Verified.svg").default}
                                 className="img-fluid Verified-User" alt=""/> : null}
            </div>
            <div className="Social-Media-Card-Body">
                {
                    options.map((option, index) => {
                        return (
                            <p className="Social-Media-Card-Body-Options" key={index}>
                                &nbsp;&nbsp;&nbsp;
                                &#x2022;
                                &nbsp;&nbsp;&nbsp;
                                {option}
                            </p>
                        );
                    })
                }
                <h6 style={{visibility: activateSocialMedia === `card${cardID}` ? "hidden" : "visible"}}
                    className="text-center Social-Media-Card-Body-Price">{price}</h6>
                <div
                    className="w-100 d-flex flex-lg-row flex-md-column flex-column justify-content-center align-items-center"
                    style={{gap: "7px"}}>
                    <Button className="align-middle" type={"primary"} action={() => {
                        setActivateSocialMedia(`card${cardID}`);
                        setCount(1)
                    }} responsive={true}>
                        افزودن
                        <img src={require("../../../assets/images/icons/AddToCart.svg").default} alt=""
                             className="img-fluid pe-2"/>
                    </Button>
                    {
                        activateSocialMedia === `card${cardID}` ?
                            <Counter count={count} setCount={setCount} setActivate={setActivateSocialMedia}/> : null
                    }
                </div>
            </div>
        </div>
    );
}

export default BuyAbleSocialMediaCard;